<div class="sync-dialog">
  <!-- ─── Cabecera ─── -->
  <div class="sync-dialog__header">
    <div class="sync-dialog__header-icon" aria-hidden="true">
      <mat-icon>receipt_long</mat-icon>
    </div>
    <div class="sync-dialog__header-text">
      <h2 class="sync-dialog__header-title">
        {{ labels.documentTitle }}
      </h2>
      <p class="sync-dialog__header-subtitle">
        {{ labels.documentSubtitle }}
      </p>
    </div>
  </div>

  <ng-container *ngIf="viewState === 'idle'">
  <!-- ─── Vista de doble confirmación antes de generar ─── -->
  <ng-container *ngIf="confirming; else normalView">
    <div
      class="sync-dialog__confirm"
      [class.np-step3]="isNpStep3Mode"
    >
      <div class="sync-dialog__confirm-icon">
        <mat-icon>rule</mat-icon>
      </div>
      <h3 class="sync-dialog__confirm-title">
        ¿Confirmar la generación de {{ totalOs }} {{ totalOs === 1 ? (isNpMode ? 'nota de pedido' : 'orden de servicio') : (isNpMode ? 'notas de pedido' : 'órdenes de servicio') }}?
      </h3>
      <p class="sync-dialog__confirm-subtitle">
        Se emitirán {{ totalOs }} {{ isNpMode ? 'NP' : 'OS' }} para {{ totalServices }} servicio(s) del
        proveedor {{ providerName }}. Esta acción es irreversible.
      </p>

      <div class="sync-dialog__confirm-stats">
        <div class="sync-dialog__stat sync-dialog__stat--compact">
          <span class="sync-dialog__stat-value">{{ totalServices }}</span>
          <span class="sync-dialog__stat-label">Servicios</span>
        </div>
        <div class="sync-dialog__stat sync-dialog__stat--compact">
          <span class="sync-dialog__stat-value">{{ totalOs }}</span>
          <span class="sync-dialog__stat-label">{{ labels.statUnitLabel }}</span>
        </div>
        <div *ngFor="let ct of payableCurrencyTotals" class="sync-dialog__stat sync-dialog__stat--compact sync-dialog__stat--accent">
          <span class="sync-dialog__stat-value">{{ ct.moneda }} {{ ct.total | formatNumber }}</span>
          <span class="sync-dialog__stat-label">Total</span>
        </div>
      </div>

      <div class="sync-dialog__confirm-actions">
        <button
          mat-stroked-button
          type="button"
          class="sync-dialog__btn sync-dialog__btn--back"
          (click)="backFromConfirm()"
        >
          <mat-icon>arrow_back</mat-icon>
          Volver al resumen
        </button>
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="sync-dialog__btn sync-dialog__btn--confirm"
          (click)="doGenerate()"
        >
          <mat-icon>check</mat-icon>
          Confirmar y generar
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #normalView>
  <!-- ─── Stepper ─── -->
  <div class="sync-dialog__steps">
    <span
      *ngFor="let stepLabel of steps; let stepIndex = index"
      class="sync-dialog__step"
      [class.sync-dialog__step--last]="stepIndex === steps.length - 1"
      [class.sync-dialog__step--active]="activeStep === stepIndex"
      [class.sync-dialog__step--done]="activeStep > stepIndex"
    >
      <button type="button" class="sync-dialog__step-btn" (click)="activeStep = stepIndex">
        <span class="sync-dialog__step-num">
          <mat-icon *ngIf="activeStep > stepIndex" class="sync-dialog__step-check">check</mat-icon>
          <span *ngIf="activeStep <= stepIndex">{{ stepIndex + 1 }}</span>
        </span>
        <span class="sync-dialog__step-label">{{ stepLabel }}</span>
      </button>
      <span
        *ngIf="stepIndex < steps.length - 1"
        class="sync-dialog__step-line"
        aria-hidden="true"
      ></span>
    </span>
  </div>

  <!-- ════════════════════════════════════════════════════════ -->
  <!-- STEP 1: Fecha de Pago Programada                       -->
  <!-- ════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="activeStep === 0">
    <div class="sync-dialog__provider-desc">
      <mat-icon>schedule</mat-icon>
      <span [innerHTML]="labels.step1ProviderDesc"></span>
    </div>

    <div class="sync-dialog__info-capsule">
      <mat-icon>info</mat-icon>
      <span>{{ labels.step1Info }}</span>
    </div>

    <div class="sync-dialog__scroll">
      <app-mass-os-itinerary-sync-card
        *ngFor="let state of itineraryStates"
        [state]="state"
        [step]="0"
        (massDateChange)="applyMassDate(state.itineraryId, $event)"
        (serviceDateChange)="updateServiceDate(state.itineraryId, $event.serviceId, $event.date, $event.ticketId)"
      >
        <div massControls class="sync-dialog__mass-date">
          <span class="sync-dialog__mass-label">Masivo:</span>
          <div class="sync-dialog__mass-date-inline">
            <input
              class="sync-dialog__mass-date-input"
              [matDatepicker]="massDatePicker"
              [value]="state.fechaMasiva"
              (dateChange)="applyMassDate(state.itineraryId, $event.value)"
              placeholder="dd/mm/aaaa"
              readonly
            />
            <mat-icon
              class="sync-dialog__mass-date-icon"
              (click)="massDatePicker.open()"
            >event</mat-icon>
            <mat-datepicker #massDatePicker [panelClass]="datepickerPanelClass"></mat-datepicker>
          </div>
          <span
            *ngIf="state.fechaMasiva"
            class="sync-dialog__mass-feedback"
          >
            Se ajustan {{ massDateAffected(state) }}
            <ng-container *ngIf="massDateSkip(state) > 0">
              · {{ massDateSkip(state) }} conservan fecha manual
            </ng-container>
          </span>
        </div>
      </app-mass-os-itinerary-sync-card>
    </div>
  </ng-container>

  <!-- ════════════════════════════════════════════════════════ -->
  <!-- STEP 2: Código de Reserva (solo OS)                     -->
  <!-- ════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="activeStep === 1 && isOsMode">
    <div class="sync-dialog__info-capsule">
      <mat-icon>vpn_key</mat-icon>
      <span>{{ labels.step2Info }}</span>
    </div>

    <div
      *ngIf="massCodeFedBack"
      class="sync-dialog__info-capsule sync-dialog__info-capsule--warn"
    >
      <mat-icon>lock</mat-icon>
      <span>
        Los códigos de reserva ingresados manualmente se conservaron y no
        fueron reemplazados por el código masivo.
      </span>
    </div>

    <div class="sync-dialog__scroll">
      <app-mass-os-itinerary-sync-card
        *ngFor="let state of itineraryStates"
        [state]="state"
        [step]="1"
        (massCodeChange)="applyMassCode(state.itineraryId, $event)"
        (serviceCodeChange)="updateServiceCode(state.itineraryId, $event.serviceId, $event.code, $event.ticketId)"
      >
        <div massControls class="sync-dialog__mass-code">
          <span class="sync-dialog__mass-label">Masivo:</span>
          <input
            type="text"
            class="sync-dialog__mass-code-input"
            placeholder="Código para todos"
            [value]="state.codigoReservaMasivo ?? ''"
            (input)="applyMassCode(state.itineraryId, $any($event.target).value)"
          />
          <span
            *ngIf="state.codigoReservaMasivo"
            class="sync-dialog__mass-feedback"
          >
            Asigna a {{ massCodeAffected(state) }}
            <ng-container *ngIf="massCodeSkip(state) > 0">
              · {{ massCodeSkip(state) }} manual(es) se conservan
            </ng-container>
          </span>
        </div>
      </app-mass-os-itinerary-sync-card>
    </div>
  </ng-container>

  <!-- ════════════════════════════════════════════════════════ -->
  <!-- Emisión y comisión (un valor para todo el lote)        -->
  <!-- ════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="isCommissionStep">
    <div *ngIf="isOsMode" class="sync-dialog__commission" style="margin-bottom: 12px">
      <label class="sync-dialog__commission-switch" [class.is-on]="asOfficial">
        <input
          type="checkbox"
          [checked]="asOfficial"
          (change)="asOfficial = $any($event.target).checked"
        />
        <span class="sync-dialog__commission-knob" aria-hidden="true"></span>
        <span class="sync-dialog__commission-copy">
          <strong>Crear como confirmada</strong>
          <span>Todo el lote nace oficial y genera PDF.</span>
        </span>
      </label>
      <div *ngIf="!asOfficial" class="sync-dialog__corte">
        <span>Plazo para confirmar el lote</span>
        <span class="sync-dialog__mass-date-inline">
          <input
            class="sync-dialog__mass-date-input"
            [matDatepicker]="cortePicker"
            [value]="freezeDeadlineDate"
            (dateChange)="applyFreezeDeadline($event.value)"
            placeholder="dd/mm/aaaa"
            readonly
          />
          <mat-icon
            class="sync-dialog__mass-date-icon"
            (click)="cortePicker.open()"
          >event</mat-icon>
          <mat-datepicker #cortePicker [panelClass]="datepickerPanelClass"></mat-datepicker>
        </span>
        <small>Ya viene calculado: 45 días antes de la fecha más cercana del lote. Tienen hasta ese día para confirmarse; mientras tanto son borrador.</small>
        <small class="sync-dialog__commission-error" *ngIf="freezeDeadlineTouched && freezeDeadlineError">{{ freezeDeadlineError }}</small>
      </div>
    </div>
    <div class="sync-dialog__info-capsule">
      <mat-icon>payments</mat-icon>
      <span>
        Opcional. Si la activas,
        {{
          isNpMode
            ? 'la misma comisión se suma al monto de cada nota de pedido'
            : 'la comisión se calcula en cada servicio o ticket'
        }}
        y se imprime en el PDF.
      </span>
    </div>

    <div class="sync-dialog__scroll">
      <div class="sync-dialog__commission">
        <label
          class="sync-dialog__commission-switch"
          [class.is-on]="commissionEnabled"
        >
          <input
            type="checkbox"
            [checked]="commissionEnabled"
            (change)="setCommissionEnabled($any($event.target).checked)"
          />
          <span class="sync-dialog__commission-knob" aria-hidden="true"></span>
          <span class="sync-dialog__commission-copy">
            <strong>Incluir comisión</strong>
            <span>Se suma al monto base de cada documento. Apagada, todo sigue igual.</span>
          </span>
        </label>

        <div *ngIf="commissionEnabled" class="sync-dialog__commission-panel">
          <div class="sync-dialog__commission-segment" role="radiogroup" aria-label="Tipo de comisión">
            <label [class.is-on]="commissionType === 'PERCENTAGE'">
              <input
                type="radio"
                name="massCommissionType"
                value="PERCENTAGE"
                [checked]="commissionType === 'PERCENTAGE'"
                (change)="setCommissionType('PERCENTAGE')"
              />
              Porcentaje
            </label>
            <label [class.is-on]="commissionType === 'FIXED'">
              <input
                type="radio"
                name="massCommissionType"
                value="FIXED"
                [checked]="commissionType === 'FIXED'"
                (change)="setCommissionType('FIXED')"
              />
              Monto fijo
            </label>
          </div>

          <label class="sync-dialog__commission-value">
            <span>Valor</span>
            <span
              class="sync-dialog__commission-box"
              [class.is-invalid]="showCommissionError"
            >
              <input
                type="number"
                min="0.01"
                step="0.01"
                [value]="commissionValue ?? ''"
                [placeholder]="commissionType === 'FIXED' ? '0.00' : ''"
                (input)="onCommissionValueInput($any($event.target).value)"
                (blur)="markCommissionTouched()"
              />
              <em>{{ commissionType === 'PERCENTAGE' ? '%' : 'fijo' }}</em>
            </span>
          </label>

          <p class="sync-dialog__commission-error" *ngIf="showCommissionError">
            {{ commissionError }}
          </p>
          <p class="sync-dialog__commission-hint" *ngIf="!showCommissionError">
            El porcentaje y el monto se ven en el resumen y en el PDF.
          </p>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ════════════════════════════════════════════════════════ -->
  <!-- Resumen (último paso)                                  -->
  <!-- ════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="isLastStep">
    <div class="sync-dialog__info-capsule sync-dialog__info-capsule--success">
      <mat-icon>check_circle</mat-icon>
      <span>{{ labels.step3Info }}</span>
    </div>

    <div
      *ngIf="totalOs === 0 || totalServices === 0"
      class="sync-dialog__info-capsule sync-dialog__info-capsule--warn"
    >
      <mat-icon>info</mat-icon>
      <span>{{ labels.step3Empty }}</span>
    </div>

    <div class="sync-dialog__summary" [class.np-step3]="isNpStep3Mode">
      <div class="sync-dialog__scroll">
        <div *ngFor="let fileGroup of fileOsGroups; let fi = index" class="sync-dialog__file">
          <div class="sync-dialog__file-header">
            <mat-icon>folder</mat-icon>
            <span class="sync-dialog__file-name">File: {{ fileGroup.fileNumber }}</span>
            <span class="sync-dialog__file-count">
              {{ fileGroup.fechaGrupos.length }} {{ labels.fileCountLabel }}
            </span>
          </div>

          <div *ngFor="let fechaGroup of fileGroup.fechaGrupos; let di = index" class="sync-dialog__fecha">
            <div class="sync-dialog__fecha-header">
              <mat-icon>event</mat-icon>
              <span>{{ labels.fechaGroupLabel }} {{ formatShortDate(fechaGroup.fechaPago) }}</span>
            </div>

            <div *ngFor="let monedaGroup of fechaGroup.monedaGrupos; let mi = index" class="sync-dialog__moneda">
              <div class="sync-dialog__moneda-header">
                <mat-icon>payments</mat-icon>
                <span>Moneda: {{ monedaGroup.moneda }}</span>
                <span class="sync-dialog__moneda-count">
                  {{ monedaGroup.codigoGrupos.length }} {{ labels.unitLabel }}
                </span>
              </div>

              <div *ngFor="let group of monedaGroup.codigoGrupos; let ci = index" class="sync-dialog__os-card">
                <div class="sync-dialog__os-card-header">
                  <span class="sync-dialog__os-card-badge">{{ labels.unitLabel }} Nº {{ group.seq ?? ci + 1 }}</span>
                  <span class="sync-dialog__os-card-count">
                    {{ group.units.length }} ítem(s)
                  </span>
                  <span class="sync-dialog__os-card-sep">·</span>
                  <span class="sync-dialog__os-card-total">
                    Total: {{ group.moneda }}
                    {{ (group.payableTotal ?? group.total) | formatNumber }}
                  </span>
                </div>
                <div class="sync-dialog__os-pay" *ngIf="group.commissionAmount != null">
                  <span>Monto {{ group.moneda }} {{ group.total | formatNumber }}</span>
                  <span>{{ group.commissionLabel }} {{ group.moneda }} {{ group.commissionAmount | formatNumber }}</span>
                  <strong>Total {{ group.moneda }} {{ group.payableTotal | formatNumber }}</strong>
                </div>

                <div class="sync-dialog__os-card-meta">
                  <div
                    *ngIf="isOsMode"
                    class="sync-dialog__os-card-meta-item sync-dialog__os-card-meta-item--code"
                  >
                    <mat-icon>vpn_key</mat-icon>
                    <span class="sync-dialog__os-card-meta-label">Código de reserva</span>
                    <strong>{{ group.codigoReserva || '—' }}</strong>
                  </div>
                  <div class="sync-dialog__os-card-meta-item sync-dialog__os-card-meta-item--obs">
                    <mat-icon>notes</mat-icon>
                    <span class="sync-dialog__os-card-meta-label">Observaciones</span>
                    <strong>{{ group.observaciones || '—' }}</strong>
                  </div>
                </div>

                <div class="sync-dialog__os-card-obs">
                  <span class="sync-dialog__os-card-obs-title">
                    <mat-icon>edit</mat-icon>
                    Editar observaciones
                  </span>
                  <input
                    type="text"
                    [value]="group.observaciones"
                    placeholder="Escribe las observaciones de esta {{ labels.unitLabel }} (opcional)"
                    (input)="updateOsObservaciones(group, $any($event.target).value)"
                  />
                </div>

                <div class="sync-dialog__os-card-body">
                  <div
                    class="sync-dialog__os-grid sync-dialog__os-grid--head"
                    [class.sync-dialog__os-grid--pay]="isOsMode && commissionEnabled"
                  >
                    <span>Día</span>
                    <span>Servicio</span>
                    <span>Proveedor</span>
                    <span>Fecha</span>
                    <span>Monto</span>
                    <span *ngIf="isOsMode && commissionEnabled">Comisión</span>
                    <span *ngIf="isOsMode && commissionEnabled">Total</span>
                  </div>
                  <div
                    *ngFor="let unit of group.units"
                    class="sync-dialog__os-grid"
                    [class.sync-dialog__os-grid--ticket]="unit.kind === 'ticket'"
                    [class.sync-dialog__os-grid--pay]="isOsMode && commissionEnabled"
                  >
                    <span class="sync-dialog__os-svc-day">
                      <ng-container *ngIf="unit.kind === 'ticket'">
                        <mat-icon class="sync-dialog__os-ticket-dot">confirmation_number</mat-icon>
                      </ng-container>
                      {{ unit.serviceDay }}
                    </span>
                    <span class="sync-dialog__os-svc-name">
                      {{ unit.nombreServicio }}
                      <span *ngIf="unit.kind === 'ticket'" class="sync-dialog__os-svc-ticketid">
                        • Ticket {{ unit.ticketId }}
                      </span>
                    </span>
                    <span class="sync-dialog__os-svc-provider">{{ unit.nombre }}</span>
                    <span class="sync-dialog__os-svc-date">
                      {{ formatShortDate(unit.fecha) }}
                    </span>
                    <span class="sync-dialog__os-svc-cost">
                      {{ unit.moneda }} {{ unit.total | formatNumber }}
                    </span>
                    <ng-container *ngIf="isOsMode && commissionEnabled">
                      <span class="sync-dialog__os-svc-cost">
                        {{ unit.moneda }}
                        {{ (previewCommission(unit.total)?.amount || 0) | formatNumber }}
                      </span>
                      <span class="sync-dialog__os-svc-cost">
                        {{ unit.moneda }}
                        {{ (previewCommission(unit.total)?.total || unit.total) | formatNumber }}
                      </span>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  </ng-template>
  </ng-container>

  <!-- ════════════════════════════════════════════════════════ -->
  <!-- GENERANDO (job PENDING / PROCESSING)                    -->
  <!-- ════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="viewState === 'generating'">
    <div class="sync-dialog__center" [class.np-step3]="isNpStep3Mode">
      <mat-spinner [diameter]="44"></mat-spinner>
      <p class="sync-dialog__state-title">{{ labels.generatingTitle }}</p>
      <p class="sync-dialog__state-subtitle">
        {{ labels.generatingSubtitle }}
      </p>
    </div>
  </ng-container>

  <!-- ════════════════════════════════════════════════════════ -->
  <!-- ERROR DE JOB                                            -->
  <!-- ════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="viewState === 'error'">
    <div class="sync-dialog__center" [class.np-step3]="isNpStep3Mode">
      <div class="sync-dialog__alert sync-dialog__alert--error">
        <mat-icon>error_outline</mat-icon>
        <div>
          <strong *ngIf="creationErrorTitle">{{ creationErrorTitle }}</strong>
          <span>{{ creationErrorMessage }}</span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ════════════════════════════════════════════════════════ -->
  <!-- RESULTADO                                               -->
  <!-- ════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="viewState === 'result'">
    <div class="sync-dialog__result" [class.np-step3]="isNpStep3Mode">
      <div
        *ngIf="hasCreated && !hasWarnings && !hasRejections"
        class="sync-dialog__banner sync-dialog__banner--success"
      >
        <mat-icon>check_circle</mat-icon>
        <div>
          <strong>{{ labels.resultSuccessTitle }}</strong>
          <span>{{ createdCount }} {{ isNpMode ? 'NP' : 'OS' }} generada(s)</span>
        </div>
      </div>

      <div
        *ngIf="hasCreated && (hasWarnings || hasRejections)"
        class="sync-dialog__banner sync-dialog__banner--warn"
      >
        <mat-icon>warning_amber</mat-icon>
        <div>
          <strong>{{ labels.resultWarnTitle }}</strong>
          <span>{{ createdCount }} {{ isNpMode ? 'NP' : 'OS' }} generada(s). Revisa las advertencias.</span>
        </div>
      </div>

      <div
        *ngIf="!hasCreated"
        class="sync-dialog__banner sync-dialog__banner--error"
      >
        <mat-icon>error_outline</mat-icon>
        <div>
          <strong>{{ labels.resultErrorTitle }}</strong>
          <span>{{ labels.resultErrorSubtitle }}</span>
        </div>
      </div>

      <div class="sync-dialog__result-scroll">
        <section *ngIf="warningCards.length > 0" class="sync-dialog__block">
          <h3 class="sync-dialog__block-title sync-dialog__block-title--warn">
            Advertencias ({{ warningCards.length }})
          </h3>
          <div
            *ngFor="let card of warningCards"
            class="sync-dialog__issue-card sync-dialog__issue-card--warn"
          >
            <mat-icon>info</mat-icon>
            <div>
              <strong>{{ card.title }}</strong>
              <p>{{ card.body }}</p>
            </div>
          </div>
        </section>

        <section *ngIf="rejectionCards.length > 0" class="sync-dialog__block">
          <h3 class="sync-dialog__block-title sync-dialog__block-title--error">
            No procesados ({{ rejectionCards.length }})
          </h3>
          <div
            *ngFor="let card of rejectionCards"
            class="sync-dialog__issue-card sync-dialog__issue-card--error"
          >
            <mat-icon>block</mat-icon>
            <div>
              <strong>{{ card.title }}</strong>
              <p>{{ card.body }}</p>
              <p *ngIf="card.serviceId">Servicio: {{ card.serviceId }}</p>
            </div>
          </div>
        </section>

        <section *ngIf="isOsMode && creationResult?.createdOrders?.length" class="sync-dialog__block">
          <h3 class="sync-dialog__block-title">Desglose a pagar</h3>
          <article *ngFor="let os of creationResult?.createdOrders" class="sync-dialog__os-pay">
            <strong>OS {{ os.displayCode || os.orderNumber }}</strong>
            <ng-container *ngIf="os.commissionAmount != null">
              <span>Monto {{ os.baseAmount | formatNumber }}</span>
              <span>Comisión ({{ os.commissionPercent }}%) {{ os.currency }} {{ os.commissionAmount | formatNumber }}</span>
            </ng-container>
            <strong *ngIf="os.total != null || os.baseAmount != null">
              Total {{ os.currency }} {{ (os.total ?? os.baseAmount) | formatNumber }}
            </strong>
          </article>
        </section>

        <section *ngIf="isOsMode && creationResult?.createdOrders?.length" class="sync-dialog__block">
          <h3 class="sync-dialog__block-title">{{ labels.createdResultLabel }}</h3>
          <article
            *ngFor="let os of creationResult?.createdOrders"
            class="sync-dialog__os-result-card"
          >
            <div>
              <span class="sync-dialog__os-result-label">{{ labels.createdResultNumberLabel }}</span>
              <strong class="sync-dialog__os-result-number">
                N° {{ os.displayCode || os.orderNumber }}
              </strong>
            </div>
            <span
              class="os-status"
              [attr.data-os-status]="(os.orderStatus || '').toUpperCase()"
            >
              {{ os.orderStatus }}
            </span>
            <button
              *ngIf="os.orderStatus === 'PRELIMINAR'"
              type="button"
              class="sync-dialog__os-confirm"
              [disabled]="confirmingOrderId === os.orderId"
              (click)="confirmarOs(os.orderId)"
            >
              {{ confirmingOrderId === os.orderId ? 'Confirmando...' : 'Confirmar OS' }}
            </button>
          </article>
        </section>

        <section *ngIf="isNpMode && npPayRows.length" class="sync-dialog__block">
          <h3 class="sync-dialog__block-title">Desglose a pagar</h3>
          <article *ngFor="let row of npPayRows" class="sync-dialog__os-pay">
            <strong>OP {{ row.number }}</strong>
            <ng-container *ngIf="row.amount != null">
              <span>Monto {{ row.base | formatNumber }}</span>
              <span>{{ row.label }} {{ row.amount | formatNumber }}</span>
            </ng-container>
            <strong>Total {{ row.total | formatNumber }}</strong>
          </article>
        </section>

        <section *ngIf="isNpMode && creationPurchaseNoteResult?.createdPurchaseNotes?.length" class="sync-dialog__block">
          <h3 class="sync-dialog__block-title">{{ labels.createdResultLabel }}</h3>
          <article
            *ngFor="let np of creationPurchaseNoteResult?.createdPurchaseNotes"
            class="sync-dialog__os-result-card"
          >
            <div>
              <span class="sync-dialog__os-result-label">{{ labels.createdResultNumberLabel }}</span>
              <strong class="sync-dialog__os-result-number">
                N° {{ np.purchaseNoteNumber }}
              </strong>
            </div>
            <span class="sync-dialog__os-result-status">{{ np.purchaseNoteStatus }}</span>
          </article>
        </section>
      </div>
    </div>
  </ng-container>

  <!-- ─── Footer ─── -->
  <div class="sync-dialog__footer" [class.np-step3]="isNpStep3Mode">
    <div
      *ngIf="isLastStep && viewState === 'idle' && !confirming"
      class="sync-dialog__footer-summary"
    >
      <div class="sync-dialog__stat sync-dialog__stat--compact">
        <span class="sync-dialog__stat-value">{{ totalServices }}</span>
        <span class="sync-dialog__stat-label">Servicios</span>
      </div>
      <div class="sync-dialog__stat sync-dialog__stat--compact">
        <span class="sync-dialog__stat-value">{{ totalOs }}</span>
        <span class="sync-dialog__stat-label">{{ labels.statUnitLabel }}</span>
      </div>
      <div class="sync-dialog__stat sync-dialog__stat--compact">
        <span class="sync-dialog__stat-value" title="{{ providerName }}">{{ providerName }}</span>
        <span class="sync-dialog__stat-label">Proveedor</span>
      </div>
      <div
        *ngFor="let ct of payableCurrencyTotals"
        class="sync-dialog__stat sync-dialog__stat--compact sync-dialog__stat--accent"
      >
        <span class="sync-dialog__stat-value">
          {{ ct.moneda }} {{ ct.total | formatNumber }}
        </span>
        <span class="sync-dialog__stat-label">Total</span>
      </div>
    </div>

    <div class="sync-dialog__footer-side">
      <!-- CARGANDO -->
      <ng-container *ngIf="viewState === 'generating'">
        <button
          mat-stroked-button
          type="button"
          class="sync-dialog__btn sync-dialog__btn--cancel"
          disabled
        >
          Cancelar
        </button>
      </ng-container>

      <!-- ERROR DE JOB -->
      <ng-container *ngIf="viewState === 'error'">
        <button
          mat-stroked-button
          type="button"
          class="sync-dialog__btn sync-dialog__btn--cancel"
          (click)="cerrar()"
        >
          Cerrar y actualizar
        </button>
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="sync-dialog__btn sync-dialog__btn--confirm"
          (click)="retry()"
        >
          Reintentar
        </button>
      </ng-container>

      <!-- RESULTADO -->
      <ng-container *ngIf="viewState === 'result'">
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="sync-dialog__btn sync-dialog__btn--confirm"
          (click)="cerrar()"
        >
          Entendido
        </button>
      </ng-container>

      <!-- FORMULARIO (idle) -->
      <ng-container *ngIf="viewState === 'idle'">
        <button
          mat-stroked-button
          type="button"
          class="sync-dialog__btn sync-dialog__btn--cancel"
          (click)="cancel()"
        >
          Cancelar
        </button>

        <button
          *ngIf="activeStep > 0 && !confirming"
          mat-stroked-button
          type="button"
          class="sync-dialog__btn sync-dialog__btn--back"
          (click)="prevStep()"
        >
          <mat-icon>arrow_back</mat-icon>
          Anterior
        </button>

        <button
          *ngIf="!isLastStep && !confirming"
          mat-flat-button
          color="primary"
          type="button"
          class="sync-dialog__btn sync-dialog__btn--next"
          (click)="nextStep()"
        >
          Siguiente
          <mat-icon>arrow_forward</mat-icon>
        </button>

        <button
          *ngIf="isLastStep && !confirming"
          mat-flat-button
          color="primary"
          type="button"
          class="sync-dialog__btn sync-dialog__btn--confirm"
          [disabled]="totalOs === 0 || totalServices === 0"
          (click)="confirm()"
        >
          <mat-icon>check</mat-icon>
          {{ labels.generationButton }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
